import React, {
    createContext,
    useCallback,
    useContext,
    useState,
} from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const storedUser =
                localStorage.getItem("userdata");

            return storedUser
                ? JSON.parse(storedUser)
                : null;
        } catch (error) {
            localStorage.removeItem("userdata");
            return null;
        }
    });

    const [isAuthenticated, setIsAuthenticated] =
        useState(() => {
            const token =
                localStorage.getItem("login_token");

            return Boolean(
                token &&
                token !== "undefined" &&
                token !== "null"
            );
        });

    const login = useCallback((userdata) => {
        const token = userdata?.login_token;

        if (
            !token ||
            token === "undefined" ||
            token === "null"
        ) {
            console.error(
                "Authentication failed: login_token missing"
            );

            return false;
        }

        localStorage.setItem(
            "userdata",
            JSON.stringify(userdata)
        );

        localStorage.setItem(
            "login_token",
            token
        );

        localStorage.setItem(
            "loginTime",
            Date.now().toString()
        );

        setUser(userdata);
        setIsAuthenticated(true);

        return true;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("login_token");
        localStorage.removeItem("userdata");
        localStorage.removeItem("loginTime");

        setUser(null);
        setIsAuthenticated(false);
    }, []);

    return (
        <AuthContext.Provider
            value={{
                user,
                isAuthenticated,
                login,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (!context) {
        throw new Error(
            "useAuth must be used inside AuthProvider"
        );
    }

    return context;
};